import {inject} from "@angular/core";
import { ResolveFn } from '@angular/router';
import {AuthFirebaseService} from "./marketplace/service/auth-firebase.service";

export const TokenResolver: ResolveFn<any> = (route, state) => {
  const authFirebaseService :AuthFirebaseService = inject(AuthFirebaseService);
  return authFirebaseService._initDataToken()
};
